import { render, staticRenderFns } from "./ValoresComponent.vue?vue&type=template&id=45bf81e8&scoped=true"
import script from "./ValoresComponent.vue?vue&type=script&lang=js"
export * from "./ValoresComponent.vue?vue&type=script&lang=js"
import style0 from "./ValoresComponent.vue?vue&type=style&index=0&id=45bf81e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bf81e8",
  null
  
)

export default component.exports